import React from 'react';
import PropTypes from 'prop-types';
import generatePath from '~settings/routing';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

export default class BreadCrumbs extends React.Component {
  constructor() {
    super();
    this.thirdBreadcrumbList = [
      'commission',
      'edit',
      'deposit-and-fees',
      'record',
      'listing-management',
      'terms',
    ];
  }
  render() {
    const { t, propertySlug, getFilters, type } = this.props;
    return (
      <div className="bread-crumbs">
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link className="bread-crumbs__text" to={generatePath('properties', {}, getFilters())}>
              {t('cms:cms.header.menu_link.list')}
            </Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Choose>
              <When condition={type === 'homepage'}>
                <span className="bread-crumbs__text">{t('cms:cms.header.menu_link.homepage')}</span>
              </When>
              <Otherwise>
                <Link
                  className="bread-crumbs__text"
                  to={generatePath('property.homepage', { propertySlug })}
                >
                  {t('cms:cms.header.menu_link.homepage')}
                </Link>
              </Otherwise>
            </Choose>
          </Breadcrumb.Item>
          <If condition={this.thirdBreadcrumbList.indexOf(type) !== -1}>
            <Breadcrumb.Item>
              <span className="bread-crumbs__text">
                {t(`cms:cms.header.menu_link.${type.replace(/-/g, '_')}`)}
              </span>
            </Breadcrumb.Item>
          </If>
        </Breadcrumb>
      </div>
    );
  }
}

BreadCrumbs.propTypes = {
  t: PropTypes.func.isRequired,
  propertySlug: PropTypes.string,
  getFilters: PropTypes.func,
  type: PropTypes.string,
};

BreadCrumbs.defaultProps = {
  t: () => {},
  propertySlug: '',
  getFilters: () => {},
  type: '',
};
